<script>
    export let videos;
    export let index = 0;
    let videoId;
    function changeIndex(amount){
        index += amount
    }

    $: if (index>=videos.length){
        index = 0;
        videoId = videos[0].split('?v=')[1];
    }
    $: if (index<videos.length){
        videoId = videos[index].split('?v=')[1];
    }
    
</script>

<div id="container">
    <div id="left">
        {#if videos.length!==0 && index !== 0}
            <div class="arrow" on:click={()=>changeIndex(-1)}>&ltrif;</div>
        {/if}
    </div>
    <div id="center">
        <div id="video-container">
            <iframe title="meetup recording" width="560" height="315" src="https://www.youtube.com/embed/{videoId}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div>{videos[index]}</div>
    </div>
    <div id="right">
        {#if videos.length!==0 && index!=videos.length-1}
            <div class="arrow" on:click={()=>changeIndex(1)}>&rtrif;</div>
        {/if}
    </div>
</div>

<style>
    #container {
        display:grid;
        place-items: center;
        grid-template-columns: 10% 80% 10%;
        width: 100%;
    }
    .arrow {
        /* font-size: 7rem; */
        font-size: 130px;
        cursor: pointer;
    }
</style>